import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
// todo: add dependency. ideally this should not be reqd with react-18. but baseui internally uses this.
import { UIDReset } from 'react-uid';
import { LayersManager } from '../layer';
var CustomBaseProvider = function (props) { return (_jsx(LayersManager, __assign({ zIndex: props.zIndex, host: props.host }, { children: _jsx(UIDReset, __assign({ prefix: "bui" }, { children: props.children }), void 0) }), void 0)); };
export default CustomBaseProvider;
